import {
  ORCHESTRATOR_CONFIG_EDIT_PERMISSIONS,
} from '../../shared/security/permission-catalog.js';
import type { AuthUser } from '@/lib/types';

export { ORCHESTRATOR_CONFIG_EDIT_PERMISSIONS };

export function hasPermission(user: AuthUser | null | undefined, slug: string): boolean {
  return Boolean(user?.permissions?.includes(slug));
}

export function hasAnyPermission(user: AuthUser | null | undefined, slugs: readonly string[]): boolean {
  return slugs.some((slug) => hasPermission(user, slug));
}

/** Orchestrator settings dialogs — orchestrator.edit, or delivery_rules.edit before migration 455. */
export function canEditOrchestratorConfig(user: AuthUser | null | undefined): boolean {
  return hasAnyPermission(user, ORCHESTRATOR_CONFIG_EDIT_PERMISSIONS);
}
